/* global buffer, document */
import React from 'react';
import ReactDOM from 'react-dom';
import InstagramGridPage from './components/App';

buffer.InstagramGridPage = function(data) {
  return {
    render: function() {
      ReactDOM.render(
        <InstagramGridPage
          logoSrc={data.profile_avatar}
          accountName={data.profile_username}
          posts={data.updates_from_instagram}
          links={data.custom_links}
        />,
        document.getElementById('instagram-grid-page')
      );
    }
  };
};



/** WEBPACK FOOTER **
 ** ./app/webroot/js/instagramBioGrid/app.js
 **/